module.exports = __webpack_public_path__ + "img/title_3.d8e93b70.png";